
const COLUMNS_PER_ROW = 4

export default {
  name: 'DropdownNormal',

  props: {
    name: {
      type: String,
      default: '',
    },
    icon: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
    description: {
      type: String,
      default: '',
    },
    items: {
      type: Array,
      default: () => [],
    },
    viewAll: {
      type: Object,
      default: null,
    },
  },

  computed: {
    isRowFull() {
      return this.items.length % COLUMNS_PER_ROW === 0
    },
  },

  methods: {
    handleItemClick(item) {
      const event = new CustomEvent('dropdown:item-click', {
        detail: { item },
      })
      window.dispatchEvent(event)
    },

    handleViewAllClick() {
      if (!this.viewAll) return
      const event = new CustomEvent('dropdown:view-all-click', {
        detail: { viewAll: this.viewAll },
      })
      window.dispatchEvent(event)
    },
  },
}
